var map = {
	"./fb.svg": 351,
	"./ig.svg": 8771,
	"./like.png": 5827,
	"./ln.svg": 8548,
	"./mail.svg": 1661,
	"./ph.svg": 6090,
	"./tg.svg": 2619,
	"./tw.svg": 2623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5234;